import React, { Suspense, lazy } from "react";
import "core/i18n";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MessageScreen from "modules/MessageScreen";

const LazyHostedForm = lazy(() => import("modules/forms/hosted/HostedForm"));
const LazyDoubleOptInConfirmation = lazy(() => import("modules/subscriptions/doubleOptInConfirmation/Overview"));
const LazyOldSubscriptionPreferences = lazy(() => import("modules/subscriptions/subscriptionPreferences/OldSubscriptionPreferences"));
const LazyEmailWebview = lazy(() => import("modules/emailWebview/Overview"));
const LazyCampaignWebview = lazy(() => import("modules/campaignWebview/Overview"));
const LazyOldUnsubscribedPage = lazy(() => import("modules/subscriptions/unsubscribe/OldUnsubscribedPage"));
const LazyOrdersOverview = lazy(() => import("modules/orders/Overview"));
const LazyVouchersOverview = lazy(() => import("modules/vouchers/Overview"));
const LazyNewUnsubscribedPage = lazy(() => import("modules/subscriptions/unsubscribe/NewUnsubscribedPage"));
const LazyNewSubscriptionPreferences = lazy(() => import("modules/subscriptions/subscriptionPreferences/NewSubscriptionPreferences"));
const LazyQrCodeRoutes = lazy(() => import("./QrCodeRoutes"));

export default function Router() {
    return (
        <BrowserRouter>
            <Suspense fallback={null}>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <MessageScreen
                                title={"Forms"}
                                description={"Nothing lives here..."}
                            />
                        }
                    />
                    <Route path={"/forms/:formUuid/*"} element={<LazyHostedForm />} />
                    <Route path={"/vouchers/:voucherUuid/:contactUuid"} element={<LazyVouchersOverview />} />
                    <Route path={"/orders/:orderId"} element={<LazyOrdersOverview />} />
                    <Route path={"/double-opt-in-confirmation"} element={<LazyDoubleOptInConfirmation />} />
                    <Route path={"/email-webview/:uuid"} element={<LazyEmailWebview />} />
                    <Route path={"/campaign-webview/:campaignUuid"} element={<LazyCampaignWebview />} />

                    {/* OLD */}
                    <Route path="/subscription-preferences/:contactId" element={<LazyOldSubscriptionPreferences />} />
                    <Route path="/unsubscribe/:contactUuid" element={<LazyOldUnsubscribedPage />} />

                    {/* NEW */}
                    <Route path="/subscription-preferences" element={<LazyNewSubscriptionPreferences />} />
                    <Route path="/unsubscribe" element={<LazyNewUnsubscribedPage />} />

                    <Route path={"/qr"} element={<LazyQrCodeRoutes />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}